export const translateFolderId = 'fa6d0875-53cb-45e7-a662-3cb23ecb4bef';